"use strict";

/**
 * Initialises the mega navigation modal functionality
 * Handles opening/closing of dropdown menus with grandchild navigation items
 */
function initMenuModal() {
  const menuButtons = document.querySelectorAll("[data-meganav-link]");
  const modalOuters = document.querySelectorAll("[data-meganav-modal]");
  if (!menuButtons) return;

  /**
   * Finds the closest parent element matching the given selector
   * @param {Element} elem - Starting element
   * @param {string} selector - CSS selector to match
   * @returns {Element|null} - Closest matching element or null
   */
  const getClosest = function getClosest(elem, selector) {
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return elem;
    }

    return null;
  };

  /**
   * Handles click events on mega navigation links
   * Opens modal with grandchild menu content
   * @param {Event} event - Click event
   */
  function handleMenuLinkClick(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const parentMenu = getClosest(link, ".site-nav--has-grandchildren");
    const currentModalOuter = parentMenu.querySelector("[data-meganav-modal]");
    const modalInner = currentModalOuter.querySelector("[data-meganav-modal-inner]");
    const grandchildMenu = link.nextElementSibling;
    const closeBtn = document.createElement("button");

    // Clear modal content and create close button
    modalInner.innerHTML = "";
    closeBtn.classList.add("site-nav__modal-close");
    closeBtn.setAttribute("aria-label", "Close");

    // Clone and append grandchild menu to modal
    const copiedTargetMenu = grandchildMenu.cloneNode(true);
    copiedTargetMenu.id = "".concat(copiedTargetMenu.id, "-copy");
    modalInner.appendChild(copiedTargetMenu);
    modalInner.appendChild(closeBtn);

    // Remove column layout for menus with fewer than 4 items
    if (modalInner.childNodes) {
      const newMenu = modalInner.childNodes[0];
      const newMenuList = newMenu.querySelectorAll("li");

      if (newMenuList.length < 4) {
        newMenu.classList.remove("has-columns");
      }
    }

    currentModalOuter.classList.add("open");
    requestAnimationFrame(() => {
      window.scrollToAnchorTop("site-nav", 0);
    });
  }

  /**
   * Closes the modal by removing the 'open' class
   * @param {Element} elementToClick - Modal element to close
   */
  function closeModal(elementToClick) {
    elementToClick.classList.remove("open");
  }

  // Add event listeners for modal interactions
  modalOuters.forEach(function (modal) {
    // Close modal when clicking outside
    modal.addEventListener("click", function (event) {
      const isOutside = !event.target.closest(".modal-inner");
      if (isOutside) closeModal(modal);
    });

    // Close modal on Escape key
    window.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeModal(modal);
    });
  });

  // Add click handlers to menu buttons
  menuButtons.forEach(function (menuItem) {
    return menuItem.addEventListener("click", handleMenuLinkClick);
  });
}

// Initialise menu modal functionality when page loads
window.onload = function () {
  initMenuModal();
};
